import { useStaticQuery, graphql } from "gatsby"
import { useLoginUrl } from "./login"

// only one query per file, so we put each url in its own file

export const useRegistrationUrl = () => {
  const data = useStaticQuery(registrationUrlQuery)
  return (data.pssHeaderLink || {}).url
}

/**
 * @return The registration url with the pageUrl as parameter
 *         so that the user will get there after registration.
 */
export const useRegistrationUrlForPage = (pageUrl) => {
  const registrationUrl = useRegistrationUrl()
  const loginUrl = useLoginUrl()
  if (!pageUrl) {
    return registrationUrl
  }
  return `${registrationUrl}&orig_authz_uri=${encodeURIComponent(
    `${loginUrl}?forward_url=${encodeURIComponent(pageUrl)}`
  )}`
}

const registrationUrlQuery = graphql`
  query RegistrationUrlQuery {
    pssHeaderLink(key: { eq: "registrationUrl" }) {
      url
    }
  }
`
